import { IApplicationState } from '@store'

export const selectDefaultAdAccountId = (state: IApplicationState): string | undefined => {
  const adAccounts = state.facebookAds.accounts
  return adAccounts.length ? adAccounts[0].id : undefined
}
